var TotpStreamUseCase = /** @class */ (function () {
    function TotpStreamUseCase(streamRepo) {
        this.streamRepo = streamRepo;
    }
    TotpStreamUseCase.prototype.streamQuote = function (userId, userType) {
        this.streamRepo.streamTotp(userId, userType);
    };
    return TotpStreamUseCase;
}());
export default TotpStreamUseCase;
